import type {
  AiDraftInput,
  AiDraftResponse,
  AiSearchInput,
  AiSearchResponse,
  AiStatusDetail,
  Paginated,
  CustomerListItem,
} from '@brechoflow/contracts';
import { http, isApiError } from '@/lib/api';

export const aiKeys = { status: ['ai', 'status'] as const };

export const aiApi = {
  status: () => http.get<AiStatusDetail>('/ai/status'),
  draft: (b: AiDraftInput) => http.post<AiDraftResponse>('/ai/drafts', b),
  search: (b: AiSearchInput) => http.post<AiSearchResponse>('/ai/search', b),
  customers: (q: string, signal?: AbortSignal) => http.get<Paginated<CustomerListItem>>('/customers', { q, pageSize: 8 }, signal),
};

/** O provedor de IA não está disponível (503 `ai_unavailable`). */
export const isAiUnavailable = (e: unknown) => isApiError(e) && e.statusCode === 503 && e.code === 'ai_unavailable';
